module.exports = __webpack_public_path__ + "c0214b9abb4b352e95d18c8caa19fd40.png";


//////////////////
// WEBPACK FOOTER
// ./src/favicon-64.png
// module id = 501
// module chunks = 0